import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})

export class AccountService {
  constructor(private apiService: ApiService) { }

  login(payload: { userName: string; password: string }): Observable<any> {
    return this.apiService.post('/account/login', payload).pipe(
      map((res: any) => {
        return {
          message: res.message,
          accessToken: res.accessToken,
          userId: res.userId,
          role: res.role,
          instanceId: res.instanceId,
          name: res.name,
          timeZone: res.timeZone
        };
      })
    );
  }


  ifLoggedIn() {

    let isSessionExp = localStorage.getItem('sessionExpired');
    let isLogin = localStorage.getItem('accessToken');
    if (isSessionExp) {
      return 'Expired';
    } else if (isLogin) {
      return 'Valid';
    } else {
      return 'Invalid';
    }

  }

}

